//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['list', 'from'],
  data: function data() {
    return {
      colors: ['linear-gradient(180deg, #FFF6F1 0%, #FFF0E8 100%)', 'linear-gradient(180deg, #FFF6F1 0%, #FFF0E8 100%)', 'linear-gradient(180deg, #FFF6F1 0%, #FFF0E8 100%)']
    };
  },
  mounted: function mounted() {
    var scrollEl = document.getElementById('brand-scroll-view-stats');
    scrollEl.addEventListener('scroll', window.StatusReportData, false);
  },
  methods: {
    gotoBrand: function gotoBrand(item) {
      var id = item.id,
          dataSeed = item.dataSeed;

      if (dataSeed) {
        window.seedAction(dataSeed);
      }

      this.go("/brand/detail/".concat(id));
    }
  }
};